import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { PlatformService } from '@evc/platform';
import { ButtonComponent, IconComponent, MenuComponent, MenuTriggerStateDirective, ModalService } from '@evc/web-components';
import { ToastrService } from 'ngx-toastr';
import { switchMap } from 'rxjs/operators';
import { GradeLibraryService } from '../services/grade-library.service';
import { GradeLibraryVersion } from '../interfaces/grade-library-version';
import { InspectionSetupModalComponent } from '../inspection-setup-modal/inspection-setup-modal.component';

@Component({
  selector: 'app-inspection-setup',
  templateUrl: './inspection-setup.component.html',
  styleUrls: ['./inspection-setup.component.scss'],
  imports: [CommonModule, DatePipe, MenuComponent, MenuTriggerStateDirective, ButtonComponent, IconComponent],
})
export class InspectionSetupComponent implements OnInit {
  public version: GradeLibraryVersion;

  readonly #gradeLibraryService = inject(GradeLibraryService);
  readonly #modalService = inject(ModalService);
  readonly #toastService = inject(ToastrService);
  readonly #platformService = inject(PlatformService);

  public ngOnInit(): void {    
    this.#platformService.ready$
      .pipe(switchMap(() => this.#gradeLibraryService.getVersion()))
      .subscribe((version: GradeLibraryVersion) => {
        this.version = version;
      });
  }

  public openModal(): void {
    this.#modalService
      .open$<GradeLibraryVersion>(InspectionSetupModalComponent, { version: this.version })
      .subscribe({
        next: version => {
          if (version) {
            this.version = version;
            this.#toastService.success('Inspection setup saved');
          } else {
            this.#toastService.error(`Couldn't save the inspection setup.`);
          }
        },
        error: () => this.#toastService.error(`Couldn't save the inspection setup.`),
      });
  }
}